import CardClass from "../html/card.js";

export default class EventLogClass {


    main
    modal
    eventHandlers = []

    constructor(){

    }

    init(){
        this.main = $('<div>')

        let hide = $('<button>')
            .attr('type', 'button')
            .addClass('btn-close btn-sm float-end')
            .on('click',() => {
                this.modal.hide()
            })

        this.modal = (new CardClass()).createCard({
            title: '<i class="bi bi-activity"></i>Event Log',
            headerClass: 'bg-warning-subtle',
            text: this.main,
            id: 'EventLogContainer',
            topButtons: hide

        })

        $('body').append(this.modal)
        this.modal.hide()
        this.startListening()

        this.eventHandlers.push(this.jobEventHandlers)
    }

    show(){


        this.modal.fadeIn()

    }

    handleEvent(eventName, eventData) {

        this.eventHandlers.forEach(eventHandler => {
            eventHandler(eventName, eventData)
        })

    }

    jobEventHandlers(eventName, eventData){
        console.log(eventName, eventData)
        if(eventName === '.job.step.new'){
            CS.EventLog.addLine(eventData)
        }else if(eventName === '.job.step.update'){
            CS.EventLog.updateLine(eventData)
        }else{
            CS.EventLog.addLine({
                txt: $('<div>').html(eventData.txt),
                job: 0,
                step: 0,
                spinner: false
            })

        }

    }

    addLine(data){
        let uid = 'line-' + data.job + '-' + data.step
        let cont = $('<div>')
            .attr('class', 'line '+uid)
            .append(data.txt)
        if(data.spinner??true)
            cont.append($('<div>').attr('class', 'loading fa-solid fa-spinner fa-spin'))

        this.main.prepend(cont)
    }

    updateLine(data){
        let uid = '.line-' + data.job + '-' + data.step
        let cls = ''
        if(data.status === 'success'){
            cls = 'fa-solid fa-check text-success'
        }
        if(data.status === 'error'){
            cls = 'fa-solid fa-xmark text-danger'
        }
        $('.loading', uid).attr('class', cls)
    }

    startListening() {
        window.Echo.channel('maintenanceChannel')
            .listenToAll((a,b) => { this.handleEvent(a,b) })
    }



}
